"use client";

import { useEffect } from "react";
import { amplitudeTrackEvent } from "@/services/AmplitudeService/AmplitudeService";

interface AmplitudeTrackerProps {
  eventName: string;
  eventProperties?: Record<string, any>;
}

export const AmplitudeTracker = ({ eventName, eventProperties }: AmplitudeTrackerProps) => {
  useEffect(() => {
    if (!eventName) return;

    const hasProperties = eventProperties && Object.keys(eventProperties).length > 0;

    if (hasProperties) {
      amplitudeTrackEvent(eventName, eventProperties);
    } else {
      amplitudeTrackEvent(eventName);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};
